import { render } from "./NcrmRecordPropertiesCard.vue?vue&type=template&id=43df1105&scoped=true"
import script from "./NcrmRecordPropertiesCard.vue?vue&type=script&lang=js"
export * from "./NcrmRecordPropertiesCard.vue?vue&type=script&lang=js"

import "./NcrmRecordPropertiesCard.vue?vue&type=style&index=0&id=43df1105&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43df1105"]])

export default __exports__